import { useTranslation } from "react-i18next";
import { APIProvider, } from '@vis.gl/react-google-maps';
import { useState } from "react";


import SectionTitle from "../Shared/SectionTitle/SecctionTitle";
import BookingForm from './BookingForm/BookingForm';
import GoogleMap from "./GooogleMap/GoogleMap";
import { googleMapApiKey } from "../../constants/googleMapAPIKey";
import LocationContext from '../../locationContext';
import getCountryAndCodeFromPlace from '../../utils/getCountryAndCodeFromPlace';

const Booking = (props) => {
    const { t } = useTranslation();
    const [pickupPlace, setPickupLocation] = useState(null);
    const [dropOffPlace, setDropoffLocation] = useState(null);
    const [country, setCountry] = useState(null);
    const [countryCode, setCountryCode] = useState(null);

    const setPickuplocationandler = (place) => {
        setPickupLocation(place);
    }

    const setDropoffLocationHandler = (place) => {
        setDropoffLocation(place);
        const { countryCode, country } = getCountryAndCodeFromPlace(place);
        setCountry(country);
        setCountryCode(countryCode);
    }

    return (
        <section id="booking">
            <LocationContext value={{
                pickupPlace: pickupPlace,
                dropOffPlace: dropOffPlace,
                country: country,
                countryCode: countryCode,
                setPickUpLocation: setPickuplocationandler,
                setDropoffLocation: setDropoffLocationHandler
            }}>
                <div className="container">
                    <SectionTitle subtitle={t('booking.subtitle')} title={t('booking.title')} />
                    <APIProvider apiKey={googleMapApiKey}>
                        <div className="row">
                            <div className="col-6" data-aos="fade-right">
                                <BookingForm />
                            </div>
                            <div className="col-6" data-aos="fade-left">
                                <GoogleMap />
                            </div>
                        </div>
                    </APIProvider>
                </div>
            </LocationContext>
        </section>
    );
}

export default Booking;